import React, { Fragment } from 'react';
import { size } from 'lodash';

import { useTranslation } from '@lt/localization';
import Icon from '../../../../../components/Icon';
import { pluralizeYears } from '../../../../../utils/pluralizeUtils';

const getKidsDelimeter = ({ index, kidsCount }) =>
  kidsCount - 1 !== index ? ', ' : '';

interface SearchParamsKidsProps {
  kids?: number[];
  isMobile?: boolean;
  hasAdjustParams?: boolean;
  baseCls: string;
}

const SearchParamsKids = ({
  kids = [],
  isMobile,
  hasAdjustParams,
  baseCls,
}: SearchParamsKidsProps) => {
  const { t } = useTranslation();
  const kidsCount = size(kids);
  const kidsPrefix = !hasAdjustParams && ':';
  if (!kidsCount) {
    return null;
  }

  return (
    <>
      <li className={`${baseCls}-tourists__item ${baseCls}-plus`} />

      <li className={`${baseCls}-tourists__item`}>
        <div className="like-h2 relative">
          {kidsCount}
          <Icon className={`${baseCls}-item__icon-small`} type="man" />
        </div>
        <div className="capitalize">
          {t('checkout.search.kids')}
          {kidsPrefix}
          <span className={`${baseCls}-tourists__children`}>
            {(!hasAdjustParams || isMobile) &&
              kids.map((age, index) => {
                const key = `${age}-${age + index}`;
                return (
                  <Fragment key={key}>
                    {`${age} ${pluralizeYears(age)}${getKidsDelimeter({
                      index,
                      kidsCount,
                    })}`}
                  </Fragment>
                );
              })}
          </span>
        </div>
      </li>
    </>
  );
};

export default SearchParamsKids;
